import { useContext } from "react";

import IncomingOrderConceptContext from "../context/IncomingOrderConceptContext";

const useIncomingOrderConcept = () => useContext(IncomingOrderConceptContext);

export default useIncomingOrderConcept;
